import { useEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
export const useScrollBarDimensions = (overflowRef) => {
    // Store scroll bar dimensions to offset shadows
    const [scrollBarWidth, setScrollBarWidth] = useState(0);
    const [scrollBarHeight, setScrollBarHeight] = useState(0);
    useEffect(() => {
        /* Skip measurements and ResizeObserver for tests */
        if (process.env.NODE_ENV === "test") {
            return;
        }
        const overflowElement = overflowRef.current;
        const updateScrollBarDimensions = () => {
            // DES-3344 - getBoundingClientRect returns zero for heights if measured before a transition,
            // which caused negative numbers below. Switched to offsetHeight/Width, and ensured a min value of 0
            const { clientWidth, offsetWidth, clientHeight, offsetHeight } = overflowElement;
            setScrollBarHeight(Math.max(0, offsetHeight - clientHeight));
            setScrollBarWidth(Math.max(0, offsetWidth - clientWidth));
        };
        // Update values on resize
        const resizeObserver = new ResizeObserver(updateScrollBarDimensions);
        resizeObserver.observe(overflowElement);
        return () => {
            resizeObserver.disconnect();
        };
    }, [overflowRef]);
    return { scrollBarWidth, scrollBarHeight };
};
